export default __webpack_public_path__ + "static/media/linkedin_icon.a6993c12.svg";